import Cookies from 'js-cookie'
import Component from '../core/Component'

export default class PopupOffer extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            buttonCloses: []
        }
    }

    prepare() {
        this.ref.buttonCloses.forEach(buttonClose => {
            buttonClose.addEventListener('click', this.handleButtonCloseClick)
        })
    }

    handleButtonCloseClick = () => {
        this.close()
    }

    close() {
        this.element.classList.remove('is-open')

        Cookies.set('popupOffer', 'showed', {
            expires: 1
        })
    }
}
